import { get } from 'axios';
import endpoints from 'services/endpoints';

const {
  getListboxesValues,
  getProjectStatusAndCategoryListboxesValues,
} = endpoints;

export const fieldOptions = [
  { label: 'Área', value: 'area_empresa' },
  { label: 'Categoria do projeto', value: 'categoria_projetos' },
  { label: 'Centro de custos', value: 'centro_de_custo' },
  { label: 'Função do funcionário', value: 'funcao' },
  { label: 'Nível de senioridade', value: 'nivel' },
  { label: 'País', value: 'paises' },
  { label: 'Status do projeto', value: 'status_projetos' },
];

export const getSubmitObject = (
  insertionType,
  userID,
  data,
  isDelete,
  isFunction = false,
) => {
  const submitObject = {
    [insertionType]: true,
    data: {
      [isFunction ? 'id_funcao' : 'id']: data.id_funcao ?? data.id ?? null,
      [isFunction ? 'nome_funcao' : 'descricao']:
        data.nome_funcao ?? data.descricao,
      id_usr_up: userID,
      id_usr_in: userID,
      deleted: isDelete ? 1 : 0,
    },
  };

  return submitObject;
};

export const fieldDescriptions = [
  { type: 'area_empresa', description: 'Regras internas do PDI' },
  { type: 'categoria_projetos', description: 'Edição de projetos' },
  {
    type: 'centro_de_custo',
    description:
      'Cadastro de projetos, Edição de projetos, Cadastro de funcionários, Edição de funcionários',
  },
  {
    type: 'funcao',
    description: 'Edição de funcionários, Cadastro de funcionários, PDI',
  },
  {
    type: 'nivel',
    description: 'Cadastro de funcionários, Edição de funcionários',
  },
  {
    type: 'paises',
    description: 'Cadastro de funcionários, Edição de funcionários',
  },
  {
    type: 'status_projetos',
    description: 'Edição de projetos, Cadastro de projetos',
  },
];

export const mockedTableData = [
  {
    id: 1,
    name: 'Administrador de Infraestrutura Líder',
    administrador: false,
    gestor_direto: false,
    gerente_projetos: false,
    responsavel_tecnico: false,
  },
  {
    id: 2,
    name: 'Coordenador de Engenharia',
    administrador: true,
    gestor_direto: false,
    gerente_projetos: false,
    responsavel_tecnico: true,
  },
  {
    id: 3,
    name: 'Coordenador de Planejamento',
    administrador: false,
    gestor_direto: false,
    gerente_projetos: true,
    responsavel_tecnico: true,
  },
  {
    id: 4,
    name: 'Diretor',
    administrador: true,
    gestor_direto: true,
    gerente_projetos: false,
    responsavel_tecnico: true,
  },
];

export const getTableData = async routeResource => {
  if (
    routeResource === 'categoria_projetos' ||
    routeResource === 'status_projetos'
  ) {
    const response = await get(
      `${getProjectStatusAndCategoryListboxesValues}/${routeResource}`,
    );

    return response.data?.input ?? response.data;
  }

  const response = await get(`${getListboxesValues}/${routeResource}`);
  return response.data?.input ?? response.data;
};
